import React, { ReactElement } from 'react';
import type { Route } from 'next';
import dynamic from 'next/dynamic';
import classNames from 'classnames/bind';
import RootLayout from 'layouts/RootLayout';
import proxyAxios from 'api/proxyAxios';
import { endpoints } from 'api/endpoints';
import { TopArticlesCardType } from 'sections/Home/types';
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// import { LeadFormParameters } from 'components/LeadForm/LeadForm.data';
import Breadcrumbs from 'components/Breadcrumbs';
import 'swiper/css';
import styles from 'pages/resources/freight-templates/proforma-invoice/ProformaInvoice.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/Resources/FreightTemplates/ProformaInvoice/components/SectionHeader/'));
const SectionAbout = dynamic(() => import('sections/Resources/FreightTemplates/ProformaInvoice/components/SectionAbout/'));
const SectionPurpose = dynamic(() => import('sections/Resources/FreightTemplates/ProformaInvoice/components/SectionPurpose/'));
const SectionDocuments = dynamic(() => import('sections/Resources/FreightTemplates/ProformaInvoice/components/SectionDocuments/'));
const SectionFaq = dynamic(() => import('sections/Resources/FreightTemplates/ProformaInvoice/components/SectionFaq/'));
const SectionCallToAction = dynamic(() => import('sections/Resources/FreightTemplates/ProformaInvoice/components/SectionCallToAction'));
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// const SectionForm = dynamic(() => import('sections/Resources/FreightTemplates/ProformaInvoice/components/SectionForm/'));
const SectionRelatedPosts = dynamic(() => import('sections/Resources/FreightTemplates/ProformaInvoice/components/SectionRelatedPosts/'));

interface ProformaInvoiceProps {
  articles: TopArticlesCardType[];
  pageTitle?: string;
  formUrl?: string;
  leadSubtype?: string;
};

export default function ProformaInvoice({ articles, pageTitle, formUrl, leadSubtype }: ProformaInvoiceProps) {
  return (
    <div className={cn('proforma-invoice')}>
      <div className={cn('container')}>
        <Breadcrumbs
          mTop={64}
          mode="light"
          links={[
            { title: 'Freight Templates', href: '/resources/freight-templates' as Route },
            { title: 'Proforma Invoice', href: '' as Route },
          ]}
        />
      </div>
      <SectionHeader />
      <SectionAbout />
      <SectionPurpose />
      <SectionDocuments />
      <SectionFaq />
      <SectionCallToAction />
      {/* (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
      {/* <SectionForm
        pageTitle={pageTitle}
        formUrl={formUrl}
        leadSubtype={leadSubtype}
      /> */}
      <SectionRelatedPosts articles={articles} />
    </div>
  );
};

export const getStaticProps = async () => {
  const meta = {
    title: 'Proforma Invoice Template Free Download | DF Alliance',
    description: 'Download a free proforma invoice template from DF Alliance to share preliminary billing details.',
    path: '/resources/freight-templates/proforma-invoice',
  };

  // (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
  // 'FormParameters' - parameters, passed to 'Form' component in 'SectionForm' on all Benefits pages as additional data for CRM: 
  // const FormParameters = {
  //   pageTitle: LeadFormParameters.ProformaInvoice.pageTitle,
  //   formUrl: LeadFormParameters.ProformaInvoice.formUrl,
  //   leadSubtype: LeadFormParameters.ProformaInvoice.leadSubtype,
  // };

  try {
    const { data: articles } = await proxyAxios(endpoints.blog.previewArticles + '?limit=3');

    return {
      props: {
        articles,
        ...meta,
        // (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
        // ...FormParameters,
      }
    };
  } catch (e) {
    console.log('endpoints.blog.previewArticles', e);
  }

  return {
    props: {
      articles: [],
      ...meta,
      // (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
      // ...FormParameters,
    },
  };
};

ProformaInvoice.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
